var _defs, _g, _path, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3be39dde5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 158 92 L 268.8125 92 L 268.8125 262.308594 L 158 262.308594 Z M 158 92 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44603218dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106.0625 74.0625 L 216 74.0625 L 216 243 L 106.0625 243 Z M 106.0625 74.0625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3871c1",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.251353, 187.103757)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.546875 -44.796875 L 0.546875 -56 L 39.90625 -56 L 39.90625 -44.796875 L 26.609375 -44.796875 L 26.609375 0 L 13.84375 0 L 13.84375 -44.796875 Z M 0.546875 -44.796875 "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3871c1",
    d: "M 186.304688 139.789062 C 178.722656 140.324219 172.574219 146.429688 171.976562 154.011719 C 171.464844 160.546875 175.011719 166.3125 180.359375 169.066406 L 180.359375 189.542969 C 180.359375 193.453125 183.527344 196.621094 187.4375 196.621094 C 191.34375 196.621094 194.515625 193.453125 194.515625 189.542969 L 194.515625 169.066406 C 199.519531 166.488281 202.941406 161.277344 202.941406 155.261719 C 202.941406 146.316406 195.378906 139.140625 186.304688 139.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3be39dde5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f14624",
    d: "M 218.742188 92.257812 L 158.152344 127.015625 L 209.082031 113.230469 L 245.824219 134.457031 C 245.824219 165.128906 233.621094 193.90625 213.105469 215.566406 C 197.050781 232.515625 168.726562 249.582031 168.726562 249.582031 C 174.617188 254.175781 180.859375 258.398438 187.4375 262.195312 C 237.792969 233.109375 268.8125 179.355469 268.8125 121.179688 L 218.742188 92.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44603218dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3871c1",
    d: "M 168.65625 222.148438 C 143.75 200.210938 129.042969 168.386719 129.042969 134.457031 L 129.117188 134.417969 L 210.242188 87.347656 L 187.4375 74.175781 L 106.058594 121.179688 C 106.058594 167.875 126.050781 211.722656 159.984375 242.253906 C 159.984375 242.253906 193.578125 224.707031 215.925781 201.308594 L 168.65625 222.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/T1.83624121c9f1d2a9d5fdeed57a419fe0.svg";
export { ForwardRef as ReactComponent };